import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import { ImportRowPreview } from '../../types/importTypes';

interface ImportPreviewTableProps {
  rows: ImportRowPreview[];
}

export const ImportPreviewTable: React.FC<ImportPreviewTableProps> = ({ rows }) => {
  return (
    <table style={{
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.875rem',
    }}>
      <thead>
        <tr style={{ backgroundColor: '#f9fafb', position: 'sticky', top: 0 }}>
          <th style={headerStyle}>Row</th>
          <th style={{ ...headerStyle, textAlign: 'left', minWidth: 200 }}>Title</th>
          <th style={headerStyle}>Status</th>
          <th style={{ ...headerStyle, textAlign: 'left', minWidth: 300 }}>Issues</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => {
          const warningCount = row.issues.filter(i => i.level === 'warning').length;

          return (
            <tr
              key={row.row_number}
              style={{
                backgroundColor: !row.is_valid ? '#fef2f2' : undefined,
                borderBottom: '1px solid #e5e7eb',
              }}
            >
              <td style={{ ...cellStyle, textAlign: 'center', color: '#6b7280' }}>
                {row.row_number}
              </td>
              <td style={cellStyle}>
                {row.title || <em style={{ color: '#9ca3af' }}>Missing</em>}
              </td>
              <td style={{ ...cellStyle, textAlign: 'center' }}>
                {row.is_valid ? (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: '#059669' }}>
                    <CheckCircleIcon fontSize="small" />
                    Valid
                  </span>
                ) : (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: '#dc2626' }}>
                    <ErrorIcon fontSize="small" />
                    Error
                  </span>
                )}
                {row.is_valid && warningCount > 0 && (
                  <span style={{ display: 'block', marginTop: 2, color: '#d97706', fontSize: '0.75rem' }}>
                    <WarningIcon fontSize="inherit" style={{ verticalAlign: 'middle', marginRight: 2 }} />
                    {warningCount} warning{warningCount !== 1 ? 's' : ''}
                  </span>
                )}
              </td>
              <td style={cellStyle}>
                {row.issues.length === 0 ? (
                  <span style={{ color: '#9ca3af' }}>None</span>
                ) : (
                  <ul style={{ margin: 0, paddingLeft: 16, listStyleType: 'disc' }}>
                    {row.issues.map((issue, idx) => (
                      <li
                        key={idx}
                        style={{
                          color: issue.level === 'error' ? '#dc2626' : '#d97706',
                          marginBottom: idx < row.issues.length - 1 ? 4 : 0,
                        }}
                      >
                        {issue.field && <strong>{issue.field}: </strong>}
                        {issue.message}
                      </li>
                    ))}
                  </ul>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const headerStyle: React.CSSProperties = {
  padding: '10px 12px',
  fontWeight: 600,
  textAlign: 'center',
  borderBottom: '2px solid #e5e7eb',
  color: '#374151',
};

const cellStyle: React.CSSProperties = {
  padding: '10px 12px',
  verticalAlign: 'middle',
};
